import { X, AppleLogo, AndroidLogo, Share, DotsThreeVertical } from "@phosphor-icons/react";

export default function InstallHelpModal({ onClose }) {
  return (
    <div
      data-testid="install-help-modal"
      className="fixed inset-0 z-50 bg-black/50 flex items-end sm:items-center justify-center p-0 sm:p-4"
      onClick={onClose}
    >
      <div
        className="bg-white w-full sm:max-w-md rounded-t-2xl sm:rounded-lg shadow-xl max-h-[90vh] overflow-y-auto"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="sticky top-0 bg-white border-b border-slate-200 px-5 py-4 flex items-center justify-between">
          <div className="font-bold text-lg">Install SOS on your phone</div>
          <button
            data-testid="install-help-close"
            onClick={onClose}
            className="p-1 text-slate-400 hover:text-slate-700"
            aria-label="Close"
          >
            <X size={22} />
          </button>
        </div>

        <div className="px-5 py-4 text-sm text-slate-700">
          Adding SOS to your home screen gives you a one-tap shortcut — no app
          store, no download, no login every time.
        </div>

        <div className="px-5 pb-2">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-9 h-9 rounded-full bg-slate-900 flex items-center justify-center">
              <AppleLogo size={18} weight="fill" className="text-white" />
            </div>
            <div className="font-bold text-slate-900">iPhone (Safari)</div>
          </div>
          <ol className="pl-11 space-y-1.5 text-sm text-slate-700 list-decimal">
            <li>Open this page in <b>Safari</b> (not Chrome or the Gmail browser).</li>
            <li>
              Tap the <b>Share</b> icon
              <Share size={14} weight="bold" className="inline mx-1 -mt-0.5 text-slate-500" />
              at the bottom of the screen.
            </li>
            <li>Scroll down and tap <b>Add to Home Screen</b>.</li>
            <li>Tap <b>Add</b> in the top-right corner.</li>
          </ol>
        </div>

        <div className="px-5 pt-4 pb-2 border-t border-slate-100 mt-3">
          <div className="flex items-center gap-2 mb-2">
            <div className="w-9 h-9 rounded-full bg-green-600 flex items-center justify-center">
              <AndroidLogo size={18} weight="fill" className="text-white" />
            </div>
            <div className="font-bold text-slate-900">Android (Chrome)</div>
          </div>
          <ol className="pl-11 space-y-1.5 text-sm text-slate-700 list-decimal">
            <li>Open this page in <b>Chrome</b>.</li>
            <li>
              Tap the <b>3-dot menu</b>
              <DotsThreeVertical size={14} weight="bold" className="inline mx-1 -mt-0.5 text-slate-500" />
              in the top-right.
            </li>
            <li>Tap <b>Install app</b> (or <b>Add to Home screen</b>).</li>
            <li>Tap <b>Install</b> to confirm.</li>
          </ol>
        </div>

        <div className="px-5 py-4 mt-3 bg-slate-50 border-t border-slate-100 text-xs text-slate-500">
          Once installed, open the <b>SOS</b> icon from your home screen just
          like any other app. You'll stay signed in between visits.
        </div>

        <div className="px-5 py-4 border-t border-slate-200">
          <button
            data-testid="install-help-done"
            onClick={onClose}
            className="w-full h-11 bg-slate-900 hover:bg-slate-800 text-white font-semibold rounded-md text-sm"
          >
            Got it
          </button>
        </div>
      </div>
    </div>
  );
}
